export default __webpack_public_path__ + "static/media/le_barbu_game.d5cb654d.png";